var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 110,
    viewBox: "0 0 288 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people_love_us_icon4",
    transform: "translate(-1542 -2894)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17027",
    "data-name": "\\uD0C0\\uC6D0 17027",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1723 2894)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17028",
    "data-name": "\\uD0C0\\uC6D0 17028",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1745 2894)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17029",
    "data-name": "\\uD0C0\\uC6D0 17029",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1768 2894)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17030",
    "data-name": "\\uD0C0\\uC6D0 17030",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1791 2894)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17016",
    "data-name": "\\uD0C0\\uC6D0 17016",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1677 2924)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17017",
    "data-name": "\\uD0C0\\uC6D0 17017",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1700 2924)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17018",
    "data-name": "\\uD0C0\\uC6D0 17018",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1723 2924)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17019",
    "data-name": "\\uD0C0\\uC6D0 17019",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1745 2924)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17020",
    "data-name": "\\uD0C0\\uC6D0 17020",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1768 2924)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17021",
    "data-name": "\\uD0C0\\uC6D0 17021",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1791 2924)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17003",
    "data-name": "\\uD0C0\\uC6D0 17003",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1791 2954)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16994",
    "data-name": "\\uD0C0\\uC6D0 16994",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1768 2984)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16995",
    "data-name": "\\uD0C0\\uC6D0 16995",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1791 2984)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17031",
    "data-name": "\\uD0C0\\uC6D0 17031",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1814 2894)",
    fill: "#fff",
    opacity: 0.095
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17022",
    "data-name": "\\uD0C0\\uC6D0 17022",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1814 2924)",
    fill: "#fff",
    opacity: 0.095
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17004",
    "data-name": "\\uD0C0\\uC6D0 17004",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1814 2954)",
    fill: "#fff",
    opacity: 0.095
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16996",
    "data-name": "\\uD0C0\\uC6D0 16996",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1814 2984)",
    fill: "#fff",
    opacity: 0.095
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172096",
    "data-name": "\\uADF8\\uB8F9 172096"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17032",
    "data-name": "\\uD0C0\\uC6D0 17032",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1586 2894)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17033",
    "data-name": "\\uD0C0\\uC6D0 17033",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1608 2894)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17034",
    "data-name": "\\uD0C0\\uC6D0 17034",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1631 2894)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17035",
    "data-name": "\\uD0C0\\uC6D0 17035",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1654 2894)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17036",
    "data-name": "\\uD0C0\\uC6D0 17036",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1677 2894)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17037",
    "data-name": "\\uD0C0\\uC6D0 17037",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1700 2894)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17023",
    "data-name": "\\uD0C0\\uC6D0 17023",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1586 2924)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17024",
    "data-name": "\\uD0C0\\uC6D0 17024",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1608 2924)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17025",
    "data-name": "\\uD0C0\\uC6D0 17025",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1631 2924)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17026",
    "data-name": "\\uD0C0\\uC6D0 17026",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1654 2924)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17014",
    "data-name": "\\uD0C0\\uC6D0 17014",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1586 2954)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17012",
    "data-name": "\\uD0C0\\uC6D0 17012",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1608 2954)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17005",
    "data-name": "\\uD0C0\\uC6D0 17005",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1631 2954)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17006",
    "data-name": "\\uD0C0\\uC6D0 17006",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1654 2954)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17007",
    "data-name": "\\uD0C0\\uC6D0 17007",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1677 2954)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17008",
    "data-name": "\\uD0C0\\uC6D0 17008",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1700 2954)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17009",
    "data-name": "\\uD0C0\\uC6D0 17009",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1723 2954)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17010",
    "data-name": "\\uD0C0\\uC6D0 17010",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1745 2954)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17011",
    "data-name": "\\uD0C0\\uC6D0 17011",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1768 2954)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17015",
    "data-name": "\\uD0C0\\uC6D0 17015",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1586 2984)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17013",
    "data-name": "\\uD0C0\\uC6D0 17013",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1608 2984)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17002",
    "data-name": "\\uD0C0\\uC6D0 17002",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1631 2984)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17001",
    "data-name": "\\uD0C0\\uC6D0 17001",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1654 2984)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_17000",
    "data-name": "\\uD0C0\\uC6D0 17000",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1677 2984)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16999",
    "data-name": "\\uD0C0\\uC6D0 16999",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1700 2984)",
    fill: "#c6d3e4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16998",
    "data-name": "\\uD0C0\\uC6D0 16998",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1723 2984)",
    fill: "#c6d3e4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_16997",
    "data-name": "\\uD0C0\\uC6D0 16997",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1745 2984)",
    fill: "#c6d3e4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "Day",
    transform: "translate(1542 2909)",
    fill: "#d7e0ec",
    fontSize: 20,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700,
    letterSpacing: "0.046em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18")), /*#__PURE__*/React.createElement("text", {
    id: "Day-2",
    "data-name": "Day",
    transform: "translate(1542 2939)",
    fill: "#d7e0ec",
    fontSize: 20,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700,
    letterSpacing: "0.046em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "19")), /*#__PURE__*/React.createElement("text", {
    id: "Day-3",
    "data-name": "Day",
    transform: "translate(1542 2969)",
    fill: "#212c3a",
    fontSize: 20,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700,
    letterSpacing: "0.046em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("text", {
    id: "Day-4",
    "data-name": "Day",
    transform: "translate(1542 2999)",
    fill: "#d7e0ec",
    fontSize: 20,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700,
    letterSpacing: "0.046em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "21")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountCircle);
export default __webpack_public_path__ + "static/media/countCircle.c4fa3f4a9ba706b59e660005cfc70d07.svg";
export { ForwardRef as ReactComponent };